export default {
    menu: {
        account: 'Аккаунт',
        products: 'Товары',
        priceAttr: 'Атрибуты цен',
        productNew: 'Новый товар',
        brand: 'Производители',
        brandNew: 'Новый производитель',
        category: 'Категории',
        categoryFilters: 'Фильтры категорий',
        cacheClean: 'Очистка кэша',
        categoryNew: 'Новая категория',
        delivery: 'Доставка',
        deliveryNew: 'Новая доставка',
    },
    general: {
        name: 'Название',
        brand: 'Бренд',
        category: 'Категория',
        open: 'Открыть',
        loadMore: 'Загрузить еще',
        link: 'Ссылка',
        wrongFormat: 'Не верный формат. Допускаются только латинские буквы, цифры и знак "-".',
        save: 'Сохранить',
        reset: 'Сбросить',
        delete: 'Удалить',
        add: 'Добавить',
        value: 'Значение',
        loading: 'Загрузка',
        edit: 'Изменить',
        duplicate: 'Клонировать',
        updated: 'Последние изменение',
        active: 'Активирован',
        filter: 'Фильтры',
        type: 'Тип',
        cancel: 'Отменить',
        order: 'Порядок сортировки',
        successFullyDeleted: 'Успешно удален',
        successFullyAdded: 'Успешно добавлен',
        updatedSuccessful: 'Обновлено успешно',
        noChanges: 'Нет изменений',
        sort: 'Сортировать',
        images: 'Изображения',
        title: 'Заголовок',
        description: 'Описание',
        requiredField: 'Обязательное поле',
    },
    images: {
        upload: 'Загрузить ',
        choose: 'Выбрать ',
        name: 'изборажение',
        fileName: 'Название выбранного файла',
        fileSize: 'Размеры выбранного файла',
        fileSizeHint: 'Максимальные размеры файла: 15МБ.',
        alt: 'Alt текст',
        title: 'Title текст',
        hintUsedForGoogle: 'Использяется для yandex/google.',
        dontForgetSaveProduct: 'Не забудьте сохранить товар!',
    },
    doc: {
        name: 'файл',
        title: 'Заголовок файла',
        techDescription: 'Техническая документация',
        fillNameAndBrand: 'Заполните поля "Название" и "Производитель" перед загрузкой файла',
    },
    product: {
        nameHint: 'Модель товара',
        subName: 'Под заголовок',
        subNameHint: 'Принадлежность товара к категории (тип товара), добавляется к имени',
        isVisible: 'Активирован (показывается на сайте)',
        specIcons: 'Иконка',
        imgZoom: 'Увеличение картинки',
        imageList: 'Изображения товара',
        description: 'Описание товара',
        techDescription: 'Технические хар-ки',
        howToUse: 'Как использовать',
        docList: 'Документация',
        priceList: 'Цены',
        linkHint: 'Заполняется автоматически',
        filters: 'Фильтры',
        zoomImg: 'Увеличение картинки',
        linkOpenProduct: 'Открыть продукт',
        updateProduct: 'Изменить товар',
        savedSuccessfully: 'Продукт сохранен',
        relatedProducts: 'Связанные товары',
        chooseEveryFilter: 'Выберите фильтр в каждой категории',
    },
    seo: {
        name: 'SEO',
        keywords: 'Ключевые слова',
        keywordsHint: 'Используются для поиска товаров',
        metaTitle: 'Заголовок страницы',
        metaDescription: 'Описание страницы',
    },
    price: {
        sku: 'Артикул',
        mainPrice: 'Цена',
        units: 'Цена за',
        extra: 'Дополнительная информация',
        subValue: 'Коэф. дополнительной цены',
        subValueHint: 'Рассчитывается цену основываясь на основной цене',
        multiplier: 'Множитель дополнительной цены',
        subUnits: 'Дополнительная цена за',
        hidePrice: 'Скрыть цену',
        individualPrice: 'Цена рассчитывается индивидуально',
        subPriceTitle: 'Дополнительная цена:',
        attr: 'Атрибуты',
        updateAttr: 'Изменить атрибуты',
        newAttr: 'Новый атрибут',
        insertAfter: 'Вставить после',
        priceImageUpdate: 'Изменить изображения цены',
    },
    category: {
        openCategory: 'Открыть категорию',
        parentCategory: 'Родительская категория',
        mainImage: 'Изображение кнопки категории',
        heroImage: 'Изображение для главной страницы',
        visibleInSlider: 'Показывать в слайдере',
        changeCategoryOrder: 'Изменить сортировку категорий',
        changeProductsOrder: 'Изменить сортировку товаров',
        changeChildrenOrder: 'Изменить сортировку дочерних категорий',
        additionalButtons: 'Дополнительные кнопки',
        productsNotFound: 'Товары не найдены',
        categoriesNotFound: 'Категории не найдены',
        updateCategory: 'Изменить категорию',
        description: 'Описание категории внизу страницы',
        categoryMoveWarning:
            'Внимание! Частое перемещение категорий может навредить поисковой выдачи в Yandex/Google. Изменять только при крайней необходимости.',
        categoryExtraButtonsDescription:
            'Кнопки добавляются к дочерним категориям и выглядят как категория. Находятся выше фильтров на странице.',
        newCategoryFilterItem: 'Новый элемент фильтра',
        newCategoryFilter: 'Новый фильтр',
    },
    login: {
        name: 'Логин',
        password: 'Пароль',
        enter: 'Войти',
        error: 'Ошибка входа',
    },
    cache: {
        cleanCache: 'Очистить кэш',
        cleanAllCache: 'Сбросить весь кэш',
        cleanedSuccessfully: 'Кэш сброшен',
    },
    notification: {
        success: 'Успешно',
        error: 'Ошибка',
    },
    delivery: {
        deliverySort: 'Сортировка доставки',
        conditions: 'Условия доставки',
        updateDelivery: 'Изменить доставку',
        minConditions: 'Минимальное кол-во условий доставки: ',
    },
};
